// Phase F.1 — Customer master-data + contacts API hooks
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useCustomerMasters = () =>
  useQuery({
    queryKey: ["customer-masters"],
    queryFn: () => axios.get(`${API}/customer-masters`).then((r) => r.data),
  });

export const useCustomerMaster = (id) =>
  useQuery({
    queryKey: ["customer-master", id],
    queryFn: () => axios.get(`${API}/customer-masters/${id}`).then((r) => r.data),
    enabled: !!id,
  });

export const useCreateMaster = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => axios.post(`${API}/customer-masters`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["customer-masters"] }),
  });
};

export const useUpdateMaster = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) =>
      axios.patch(`${API}/customer-masters/${id}`, body).then((r) => r.data),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ["customer-masters"] });
      qc.invalidateQueries({ queryKey: ["customer-master", vars.id] });
    },
  });
};

export const useDeleteMaster = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => axios.delete(`${API}/customer-masters/${id}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["customer-masters"] }),
  });
};

export const useCreateContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ master_id, ...body }) =>
      axios.post(`${API}/customer-masters/${master_id}/contacts`, body).then((r) => r.data),
    onSuccess: (_, vars) =>
      qc.invalidateQueries({ queryKey: ["customer-master", vars.master_id] }),
  });
};

export const useUpdateContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ contact_id, ...body }) =>
      axios.patch(`${API}/customer-masters/contacts/${contact_id}`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["customer-master"] }),
  });
};

export const useDeleteContact = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (contact_id) =>
      axios.delete(`${API}/customer-masters/contacts/${contact_id}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["customer-master"] }),
  });
};
